import React, { useCallback, useRef } from 'react';
import { ScrollFadeContainer } from '../../../ScrollFadeContainer/ScrollFadeContainer.tsx';
import { Selector } from '../Selector/Selector.tsx';
import { useWheelScroll } from '../useWheelScroll.ts';
import { useVerticalTabsScroll } from './useVerticalTabsScroll.ts';
import styles from './LayoutVertical.module.scss';
export const LayoutVertical = ({ activeTabId, onTabChange, activeIndex, wheelScrollRef, tabPosition, tabs, variant })=>{
    const selectorRef = useRef(null);
    const { panelRefs, scrollContainerRef, scrollToPanel, shouldFadeStart } = useVerticalTabsScroll({
        activeIndex: activeIndex,
        activeTabId: activeTabId,
        onTabChange: onTabChange,
        tabs: tabs
    });
    const getScrollElement = useCallback(()=>scrollContainerRef.current, [
        scrollContainerRef
    ]);
    useWheelScroll({
        containerRef: wheelScrollRef,
        selectorRef: selectorRef,
        getScrollElement: getScrollElement
    });
    const handleTabClick = (tabId, index)=>{
        onTabChange(tabId);
        scrollToPanel(index);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Selector, {
        activeIndex: activeIndex,
        activeTabId: activeTabId,
        ref: selectorRef,
        onTabClick: handleTabClick,
        tabPosition: tabPosition,
        tabs: tabs,
        variant: variant
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.verticalPanels
    }, /*#__PURE__*/ React.createElement(ScrollFadeContainer, {
        ref: scrollContainerRef,
        direction: "vertical",
        fadeStart: shouldFadeStart
    }, tabs.map((tab, index)=>/*#__PURE__*/ React.createElement("div", {
            key: tab.props.id,
            ref: (el)=>{
                panelRefs.current[index] = el;
            },
            className: styles.verticalPanel
        }, tab)))));
};
